import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "./kb-helpset.js";
import "./kb-helpset-infinite.js";
import "./kb-helpset-search.js";
import "./kb-ipc.js";
import "./kb-download.js";
import "./kb-folderview.js";
import "./kb-searchview.js";
import "./kb-property-filter.js";
import "./kb-homepage";
import "./kb-textsearch2";
import "./kb-pubsearch2";
import "./bds-property-filter";
import "./kb-not-found.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import "./kb-filepub";
import seo from "../utils/seo.js";
import { pushToDataLayer } from "../utils/tagmanager.js";
import { Router } from "@vaadin/router";
import getTargetExternalId from "../utils/getTargetExternalId.js";
import { httpError } from "../store/httpError.js";

class KbNav extends LitElement {
  static get properties() {
    return {
      showNotFound: { type: Boolean },
      controlDefs: { type: Array },
      controlData: { type: Array },
    };
  }

  constructor() {
    super();
    this.hasShortcut = false;
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.showNotFound = this.state.show_not_found;
    if (this.location.params.fileid) {
      this.fileid = this.location.params.fileid;
    }
    if (this.location.params.pagenum) {
      this.pagenum = this.location.params.pagenum;
    }

    if (this.location.params.folderId) {
      this.folderId = this.location.params.folderId;
    }

    if (this.location.params.kbrid) {
      this.kbrid = this.location.params.kbrid;
    }

    if (this.state.item_toc) {
      storeInstance.dispatch("setState", { property: "item_toc", value: null });
    }

    if (this.location.params.externalId) {
      if (
        this.location.params.externalId.toLowerCase() != "kbsearch" &&
        this.location.params.externalId.toLowerCase() != "ipcsearch" &&
        this.location.params.externalId.toLowerCase() != "fvsearch" &&
        this.location.params.externalId.toLowerCase() != "pubsearch"
      ) {
        storeInstance.dispatch("getItem", {
          langCode: this.location.params.langCode,
          externalId: this.location.params.externalId,
        });
      } else {
        //this will be query term
        if (this.location.params.searchItem) {
          //For current helpset Search
          storeInstance.dispatch("setState", {
            property: "search_term",
            value: {
              item: this.location.params.searchItem,
              searchterm: this.location.params.searchTerm,
            },
          });
          storeInstance.dispatch("getItem", {
            langCode: this.location.params.langCode,
            externalId: this.location.params.searchItem,
          });
        } else {
          storeInstance.dispatch("setState", {
            property: "search_term",
            value: {
              item: "ROOT",
              searchterm: this.location.params.searchTerm,
            },
          });
        }
      }
    } else {
      storeInstance.dispatch("getItem", {
        langCode: this.location.params.langCode,
        externalId: "ROOT",
      });
    }
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.controlDefs = this.state.panel_control_defs;
    this.controlData = this.state.control_def_data_array;
    this.showNotFound = this.state.show_not_found;
    this.page = null;

    if (this.location.params.externalId) {
      if (this.location.params.externalId == "kbsearch") {
        this.page = "search";
      }
      if (this.location.params.externalId === "pubsearch") {
        this.page = "pubsearch";
      }

      if (this.location.params.externalId === "ROOT") {
        this.page = "home";
      }
    } else {
      if (
        this.location.pathname.split("/").length <= 4 &&
        !this.location.params.externalId
      ) {
        this.page = "home";
      }
    }

    if (
      this.page != "search" &&
      this.page != "searchItem" &&
      this.page != "searchIpcItem" &&
      this.page != "searchFvItem" &&
      this.page != "home" &&
      this.page != "pubsearch"
    ) {
      if (this.state.item) {
        if (this._isIpc(this.state.item.itemLang)) {
          this.page = "ipc";
        } else if (this.state.item.item.type == "shortcut") {
          this.hasShortcut = true;
          let targetExternalId = getTargetExternalId(this.state.item.item);
          fetch(
            `/kb/jrest/getTree?externalId=${targetExternalId}&langCode=en-US`
          )
            .then((res) => {
              if (!res.ok) {
                httpError(res);
                throw Error();
              }
              return res.json();
            })
            .then((data) => {
              storeInstance.dispatch("setState", {
                property: "item",
                value: data,
              });
              this.page = data.item.type;
            })
            .catch((e) => console.log(e));
        } else {
          this.page = this.state.item.item.type;
        }
      }
    }
    this.myRender();
  }

  _isIpc(itemLang) {
    var retval = false;
    if (itemLang.hasOwnProperty("flags")) {
      if (itemLang.flags == 1) {
        retval = true;
      }
    }
    return retval;
  }

  myRender() {
    render(this.navTemplate(), this.shadowRoot);
  }

  handlePropertyFilterChange(e) {
    storeInstance.dispatch("updateJSon", {
      PanelControlValues: { lstValues: e.detail.lstValues },
    });
  }

  navTemplate() {
    if (this.showNotFound) {
      return html`<kb-not-found></kb-not-found>`;
    }

    switch (this.page) {
      case "folderview":
        return html`<kb-folderview
          .folderId="${this.folderId}"
          .fileid="${this.fileid}"
          .pagenum="${this.pagenum}"
          .searchview="${false}"
        ></kb-folderview>`; //this is category navigation. eg branches
        break;
      case "category":
        Router.go(
          `/kb/${this.state.langCode}/pubsearch?1=${this.location.params.externalId}`
        );
        return;
      case "ipc":
        seo(
          `${this.state.item.itemLang.name}`,
          this.state.item.itemLang.description
        );
        pushToDataLayer(this.state.item);
        return html`<kb-ipc
          .locationExtId=${this.location.params.externalId}
          .kbrid="${this.kbrid}"
        ></kb-ipc>`; //the rest are endpoints
        break;
      case "directHelpset":
      case "helpset":
        // seo(
        //   `${this.state.item.itemLang.name}`,
        //   this.state.item.itemLang.description
        // );
        if (this._isIpc(this.state.item.itemLang)) {
          seo(
            `${this.state.item.itemLang.name}`,
            this.state.item.itemLang.description
          );
          pushToDataLayer(this.state.item);
          return html`<kb-ipc
            .locationExtId=${this.location.params.externalId}
            .kbrid="${this.kbrid}"
          ></kb-ipc>`; //the rest are endpoints
        } else {
          pushToDataLayer(this.state.item);
          if (this.state.topic_infinite_scroll) {
            return html`<kb-helpset-infinite
              .kbrid="${this.kbrid}"
              .searchview="${false}"
            ></kb-helpset-infinite>`;
          } else {
            return html`<kb-helpset
              .locationExtId=${this.location.params.externalId}
              .hasShortcut=${this.hasShortcut}
              .kbrid="${this.kbrid}"
              .searchview="${false}"
            ></kb-helpset>`;
          }
        }

        break;
      case "download":
        seo(
          `${this.state.item.itemLang.name}`,
          this.state.item.itemLang.description
        );
        pushToDataLayer(this.state.item);
        return html`<kb-download
          .locationExtId=${this.location.params.externalId}
          .kbrid="${this.state.item.itemLang.resourceId}"
        ></kb-download>`;
        break;
      case "filePub":
        seo(
          `${this.state.item.itemLang.name}`,
          this.state.item.itemLang.description
        );
        pushToDataLayer(this.state.item);
        return html`<kb-filepub
          .pagenum=${this.location.params.searchTerm}
          kbrid=${this.kbrid}
        ></kb-filepub>`;

      case "home":
        seo(homeTitle, homeDescription);
        return html`<kb-homepage></kb-homepage>`;

      case "pubsearch":
        seo("Search Publications", "Find the publication you are looking for.");
        return html`<kb-pubsearch2></kb-pubsearch2>`;
      case "search":
        seo("Full Text Search", "Find the publication you are looking for.");
        return html` <kb-textsearch2></kb-textsearch2> `;
        break;
      case "searchItem":
        //return html`<kb-helpset-search .kbrid="${this.kbrid}"></kb-helpset-search>`;
        return html`<kb-helpset
          .kbrid="${this.kbrid}"
          .locationExtId=${this.location.params.externalId}
          .searchitem="${this.location.params.searchItem}"
          .searchview="${true}"
        ></kb-helpset>`;
        break;
      case "searchIpcItem":
        return html`<kb-ipc
          .kbrid="${this.kbrid}"
          .locationExtId=${this.location.params.externalId}
          .searchitem="${this.location.params.searchItem}"
          .searchview="${true}"
        ></kb-ipc>`;
        break;
      case "searchFvItem":
        return html`<kb-folderview
          .folderId="${this.folderId}"
          .fileid="${this.fileid}"
          .pagenum="${this.pagenum}"
          .searchitem="${this.location.params.searchItem}"
          .searchview="${true}"
        ></kb-folderview>`; //this is category navigation. eg branches
        break;
    }
  }
}

customElements.define("kb-nav", KbNav);
